import styles from "./SocialModal.module.css";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import InputText from "../../../../CommonComponents/InputControls/InputText";
import InputSelect from "../../../../CommonComponents/InputControls/InputSelect";
import { GENDER_OPTIONS } from "../../../../../constant";
import InputPhoneNumber from "../../../../CommonComponents/InputControls/InputPhoneNumber";
import useNotification from "../../../../../hooks/useNotification";
import EnterpriseServices from "../../../../../services/EnterpriseServices";
import InputDate from "../../../../CommonComponents/InputControls/InputDob";
import dayjs from "dayjs";
import AuthServices from "../../../../../services/AuthServices";
import { FaFacebook, FaFacebookF, FaGithub, FaInstagram, FaLink, FaLinkedin, FaTwitter } from "react-icons/fa";

const SocialModal = ({ isOpen, onCancel, onSubmit, data }) => {
  const [loading, setLoading] = useState(true);
  const { showNotification } = useNotification();
  const [initialData, setInitialData] = useState({});
  const [form] = Form.useForm();
  const dateFormat = "YYYY-MM-DD";


  useEffect(() => {
    if (isOpen) {
      setLoading(false);
      const initData = {
        linkedin: data?.companySocials?.linkedin,
        insta: data?.companySocials?.insta,
        twitter: data?.companySocials?.twitter,
        fb: data?.companySocials?.fb,
        github: data?.companyChannels?.github,
        companyCareerUrl: data?.companyCareerUrl
      };
      setInitialData(initData);
      form.setFieldsValue(initData);
    }
  }, [isOpen]);

  const handleOk = () => {
    onCancel(false);
  };
  const handleCancel = () => {
    onCancel(false);
  };

  const onFinish = async (values) => {
    console.warn("values", values);

    try {
      setLoading(true);
      const payloadSocials = {
        _id: data._id,
        companyCareerUrl: values.companyCareerUrl,
        companyChannels: {
          linkedin: values.linkedin,
          insta: values.insta,
          twitter: values.twitter,
          fb: values.fb,
          github: values.github,
        },
      };
      const res = await EnterpriseServices.UpdateEnterprise(payloadSocials);
      if (res) {
        if (res.statusCode === 1) {
          onSubmit();
          onCancel(false);
          showNotification("Company socials updated Successfully");
          setLoading(false);
        } else {
          handleError(`${res.statusDesc}`);
        }
      } else {
        handleError(`Error: ${res.statusDesc}`);
      }
    } catch (error) {
      console.log(error);
      if (error.statusCode === 0) {
        console.log("Error while updating company socials", error);
        handleError(error.description);
      } else {
        handleError("Error: company socials are not updated.");
      }
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleError = (error) => {
    setLoading(false);
    showNotification(error, "error");
  };

  const validator = (_, { value, countryCode, areaCode, phoneNumber }) => {
    const regex = /^\+\d{1,15}$/;
    const number = "+" + countryCode + areaCode + phoneNumber;

    if (regex.test(number)) {
      return Promise.resolve();
    } else {
      return Promise.reject("Invalid phone number");
    }
  };

  const handleChange = (key, value) => {
    setInitialData({ ...initialData, [key]: value });
  };

  return (
    <>
      <Modal
        title="Company Social Channels"
        open={isOpen}
        footer={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          name="basic"
          form={form}
          layout="vertical"
          style={{ marginTop: 20 }}
          className={styles.form_wrap}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={initialData}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className={styles.icon_wrap}>
                <FaLinkedin />
                <InputText
                  placeholder="Linkedin url"
                  name={"linkedin"}
                  onChange={handleChange}
                  rules={[
                    {
                      required: false,
                      message: "Linkedin is required !",
                      whitespace: false,
                    },
                  ]}
                />
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className={styles.icon_wrap}>
                <FaInstagram />
                <InputText
                  placeholder="Instagram url"
                  name={"insta"}
                  onChange={handleChange}
                  rules={[
                    {
                      required: false,
                      message: "Instagram is required !",
                      whitespace: false,
                    },
                  ]}
                />
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className={styles.icon_wrap}>
                <FaTwitter />
                <InputText
                  placeholder="Twitter url"
                  name={"twitter"}
                  onChange={handleChange}
                  rules={[
                    {
                      required: false,
                      message: "First name is required !",
                      whitespace: false,
                    },
                  ]}
                />
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className={styles.icon_wrap}>
                < FaFacebookF />
                <InputText
                  placeholder="Facebook url"
                  name={"fb"}
                  onChange={handleChange}
                  rules={[
                    {
                      required: false,
                      message: "Facebook is required !",
                      whitespace: false,
                    },
                  ]}
                />
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className={styles.icon_wrap}>
                <FaGithub />
                <InputText
                  placeholder="Github url"
                  name={"github"}
                  onChange={handleChange}
                  rules={[
                    {
                      required: false,
                      message: "First name is required!",
                      whitespace: false,
                    },
                  ]}
                />
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div className={styles.icon_wrap}>
                <FaLink />
                <InputText
                  placeholder="Company career page url "
                  name={"companyCareerUrl"}
                  onChange={handleChange}
                  rules={[
                    {
                      required: false,
                      message: "Career url required!",
                      whitespace: false,
                    },
                  ]}
                />
              </div>
            </Col>
          </Row>
          <div className={styles.footer}>
            <Form.Item>
              <Button
                className={styles.submit_btn}
                type="primary"
                htmlType="submit"
                loading={loading}
              >
                Submit
              </Button>
            </Form.Item>
            <Button
              className={styles.cancel_btn}
              type="secondary"
              loading={false}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default SocialModal;
